import React from 'react';
import _ from 'lodash';
import RadioButtons from '../radioButtons/radioButtons';
import RadioButton from '../radioButton/radioButton';
import ArrowLeftSymbol from '../icons/arrowLeft.svg.js';

function onChange1(generatedChildren, item, itemIndex, isRadioButtonItem, value) {
  this.props.onChange(value);
}

function scopeValue2(generatedChildren, item, itemIndex, isRadioButtonItem) {
  var value = item.props.value;
  return /*#__PURE__*/React.createElement(RadioButton, {
    key: "radioButton",
    value: value,
    name: this.groupId,
    className: item.props.className || null,
    onChange: onChange1.bind(this, generatedChildren, item, itemIndex, isRadioButtonItem, value),
    selected: this.props.value === value,
    disabled: this.props.disabled || item.props.disabled,
    showRadioSymbol: false
  }, item);
}

function scopeIsRadioButtonItem3(generatedChildren, item, itemIndex) {
  var isRadioButtonItem = this.props.tabPredicate(item);
  return /*#__PURE__*/React.createElement("li", {
    className: 'tabs-with-arrows-tab-item' + ' ' + _({
      'radio-button-item': isRadioButtonItem,
      selected: item.props && this.props.value === item.props.value
    }).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' '),
    key: 'radio' + itemIndex,
    style: {
      width: this.state.tabWidth + 'px',
      minWidth: this.state.tabWidth + 'px'
    }
  }, isRadioButtonItem ? scopeValue2.apply(this, [generatedChildren, item, itemIndex, isRadioButtonItem]) : null, isRadioButtonItem ? null : item);
}

function repeatItem4(generatedChildren, item, itemIndex) {
  return scopeIsRadioButtonItem3.apply(this, [generatedChildren, item, itemIndex]);
}

function scopeGeneratedChildren5() {
  var generatedChildren = this.generateChildren();
  return React.createElement.apply(this, ['ul', {
    className: this.props.getClassName('control-radio-buttons-list horizontal') + ' tabs-horizontal-list',
    style: {
      left: this.state.tabsListOffset + 'px'
    }
  }, _.map(generatedChildren, repeatItem4.bind(this, generatedChildren))]);
}

function onClick6() {
  this.slide('left', {
    shouldRefocusOnSelectedTab: false
  });
}

function onClick7() {
  this.slide('right', {
    shouldRefocusOnSelectedTab: false
  });
}

export default function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.getClassName(this.getRootCssClasses()),
    "data-aid": this.props.automationId,
    "data-hook": this.props.dataHook
  }, this.props.maxVisibleTabs ? null : /*#__PURE__*/React.createElement(RadioButtons, {
    key: "tabsWithoutArrowsContainer",
    value: this.props.value,
    orientation: "horizontal",
    showRadioSymbol: false,
    onChange: this.props.onChange,
    options: this.props.options,
    shouldTranslate: this.props.shouldTranslate
  }), this.props.maxVisibleTabs ? /*#__PURE__*/React.createElement("div", {
    className: "tabs-with-arrows-container",
    key: "tabsWithArrowsContainer",
    ref: this.setTabsContainerRef
  }, scopeGeneratedChildren5.apply(this, []), /*#__PURE__*/React.createElement("ul", {
    className: 'tabs-navigation-arrows-container tabs-horizontal-list' + ' ' + _({
      'align-to-left': this.state.showLeftArrow,
      'strech-to-fill-row': this.state.showLeftArrow && this.state.showRightArrow
    }).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' ')
  }, this.state.showLeftArrow ? /*#__PURE__*/React.createElement("li", {
    key: "leftArrow",
    className: "tab-navigation-arrow left-arrow-container",
    onClick: onClick6.bind(this)
  }, /*#__PURE__*/React.createElement(ArrowLeftSymbol, null)) : null, this.state.showRightArrow ? /*#__PURE__*/React.createElement("li", {
    key: "rightArrow",
    className: "tab-navigation-arrow right-arrow-container",
    onClick: onClick7.bind(this)
  }, /*#__PURE__*/React.createElement("span", {
    className: "tabs-with-arrows-right-arrow"
  }, /*#__PURE__*/React.createElement(ArrowLeftSymbol, null))) : null)) : null);
}